import { UserSquare as UserSquare_filmzi } from "./UserSquare.filmzi";
import { UserSquare as UserSquare_kojaro } from "./UserSquare.kojaro";
import { UserSquare as UserSquare_zoomg } from "./UserSquare.zoomg";
import { UserSquare as UserSquare_zoomit } from "./UserSquare.zoomit";

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case "filmzi":
      return UserSquare_filmzi;

    case "kojaro":
      return UserSquare_kojaro;

    case "zoomg":
      return UserSquare_zoomg;

    default:
      return UserSquare_zoomit;
  }
};

export const UserSquare = IconRenderer();
